export const EXOTIC_TYPE_MAP: { [p: string]: string } = {
  "ALL": "All",
  "DAILY_DOUBLE": "Daily Double",
  "EARLY_QUADRELLA": "Early Quadrella",
  "EXACTA": "Exacta",
  "EXTRA_DOUBLE": "Extra Double",
  "FIRST_FOUR": "First Four",
  "OPENING_FLUC": "Opening Fluc",
  "PLACE": "Place",
  "PLACE_FIXED_ODDS": "Place Fixed Odds",
  "QUADRELLA": "Quadrella",
  "QUINELLA": "Quinella",
  "QUINELLA_FIXED_ODDS": "Quinella Fixed Odds",
  "QUINELLA_PLACE": "Duet",
  "RUNNING_DOUBLE": "Running Double",
  "SIX_UP": "Six Up",
  "BIG6": "Big 6",
  "STARTING_PRICE": "Starting Price",
  "TOP_FLUC": "Top Fluc",
  "TREBLE": "Treble",
  "TRIFECTA": "Trifecta",
  "TRIO": "Trio",
  "WIN": "Win",
  "WIN_FIXED_ODDS": "Win Fixed Odds",
  "PLACE_FIXED_ODDS2": "Show Fixed Odds",
  "FEATURE_DOUBLE": "Feature Double",
  "PICK3": "Pick 3",
  "PICK4": "Pick 4",
  "PICK5": "Pick 5",
  "PICK6": "Pick 6",
  "PICK7": "Pick 7",
  "PICK8": "Pick 8",
  "PICK9": "Pick 9",
  "PICK10": "Pick 10",
  "PENTAFECTA": "Pentafecta",
  "OMNI": "Omni",
  "V_PICK": "V Pick",
  "PICK_X": "Pick X"
}

export const formatCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  useGrouping: false,
  notation: 'compact',
})